import { ReactComponent as AboutBoy } from '../../assets/aboutBoy.svg';
import { ReactComponent as AboutClient } from '../../assets/aboutClient.svg';
import { ReactComponent as AboutGirl } from '../../assets/aboutGirl.svg';
import { Typography } from '../../designComponents';
import {
  HeroFirst,
  HeroLast,
  HeroSectionStyled,
  Wrapper,
  WrapperInitial,
} from './style';

type Props = {};

const HeroSection = (_props: Props) => {
  return (
    <HeroSectionStyled>
      <HeroFirst>
        <AboutClient />
        <AboutGirl />
      </HeroFirst>
      <Wrapper>
        <WrapperInitial>
          <AboutGirl />
          <div className="text">
            <Typography size={32} className="text" strong>
              Unlock the potential of your building with{' '}
              <span style={{ color: '#1D8960' }}>EscapePlan</span>. Our
              blueprint services transform your vision into reality, ensuring
              precision, compliance, and peace of mind.
            </Typography>
          </div>
        </WrapperInitial>
        <AboutBoy className="img-boy" />
      </Wrapper>
      <Typography
        size={16}
        color="#333333"
        style={{ lineHeight: '28px', maxWidth: '800px', margin: '0 auto' }}
      >
        At EscapePlan, we’re your esteemed collaborator in precision blueprint
        solutions, meticulously crafting accurate and compliant CAD files and
        PDF escape plans precisely tailored to the unique specifications of your
        building.
      </Typography>

      <HeroLast>
        <div>
          <AboutGirl />
          <div style={{ margin: '0px 0px 0px 40px' }}>
            <AboutClient />
          </div>
        </div>
        <div>
          {/* <div> */}
          <AboutGirl />
          {/* </div> */}
          {/* <div>
            <AboutClient />
          </div> */}
        </div>
      </HeroLast>
    </HeroSectionStyled>
  );
};

export default HeroSection;
